module.exports = "pegasus_template/assets/column-10-basic.png";